import React from 'react';
import classNames from 'classnames';
import { Typography, TypographyColor } from '../typography/typography';
import { IconVariant } from '../icon/icon-data';
import { useMaxViewport } from '../../core/hooks/use-max-viewport';
import { Icon } from '../icon/icon';
import { useAccentBgContext } from '../accent-bg-context/accent-bg-context';
import styles from './order-button.module.scss';

type Props = {
  children: string;
  icon: IconVariant;
  onClick: () => void;
  disabled?: boolean;
};

export const OrderButton: React.FC<Props> = ({ children, icon, onClick, disabled }) => {
  const isTablet = useMaxViewport('s');
  const { isAccentBackground } = useAccentBgContext();

  let textColor: TypographyColor = 'black';
  if (isAccentBackground) textColor = 'white';
  if (disabled) textColor = 'anthrazit-75';

  return (
    <button
      className={classNames(styles.root, { [styles.accent]: isAccentBackground })}
      disabled={disabled}
      onClick={onClick}
    >
      <Typography className={styles.text} color={textColor} variant="buttontext">
        {children}
      </Typography>
      <div className={styles.cartContainer}>
        <div className={styles.slidingBackground} />
        <Icon className={styles.cartIcon} size={isTablet ? '24' : '32'} variant={icon} />
      </div>
    </button>
  );
};
